import React from 'react';
import { X } from 'lucide-react';
import { Button } from '../Button';
import { Heading } from '../Typography';

// See BulkOperationHeader.tsx for the definition of the BulkOperationSelectingTitleProps interface.
interface BulkOperationSelectingTitleProps {
  title?: string;
  onCancel?: () => void;
}

// BulkOperationTitle is a component that displays the title of the bulk operation header.  It also has a cancel "X"
// that calls the onCancel function.
export function BulkOperationSelectingTitle({ title = '', onCancel = () => {} }: BulkOperationSelectingTitleProps) {
  return (
    <>
      <div className="flex flex-row items-center">
        <Heading level="section" as="div" className="text-on-primary">
          {title}
        </Heading>
      </div>
      <div>
        <Button
          variant="ghost"
          size="small"
          onClick={onCancel}
          className="h-8 px-2 text-on-primary hover:bg-on-primary/15 lg:px-3"
        >
          Cancel Multi-Select <X className="ml-2 h-4 w-4" />
        </Button>
      </div>
    </>
  );
}
